import React from "react";
import { Helmet } from "react-helmet";
import { Typography, Row, Col, Button } from "antd";
import { ErrorBoundary } from "react-error-boundary";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Outlet, useNavigate } from "react-router-dom";

import ErrorFallback from "components/ErrorFallback";

import { AuditContainer, AuditListWrapper } from "./styled";

const { Title } = Typography;

const Report: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Helmet>
        <title>Report | Settlement</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <AuditContainer>
        <Row>
          <Col className="heading" span={24}>
            <Title level={4}>Audit - Archive</Title>
          </Col>
        </Row>

        <Row justify="space-between">
          <Col>
            <Button
              size="large"
              shape="circle"
              style={{ marginTop: 15 }}
              onClick={() => navigate(-1)}
              icon={<ArrowLeftOutlined />}
            ></Button>
          </Col>

          <Col></Col>
        </Row>

        <AuditListWrapper>
          <Outlet />
        </AuditListWrapper>
      </AuditContainer>
    </ErrorBoundary>
  );
};

export default Report;
